/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ZoomSetMatterRequest } from '../models/ZoomSetMatterRequest';
import type { ZoomTableRequest } from '../models/ZoomTableRequest';
import type { ZoomTableResponse } from '../models/ZoomTableResponse';
import type { ZoomUserResponse } from '../models/ZoomUserResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import { ZoomRecordingResponse } from '../models/ZoomRecordingResponse';
import { ZoomRecordingRequest } from '../models/ZoomRecordingRequest';
import { RingCentralExtensionResponse } from '../models/RingCentralExtensionRsponse';
import { RingCentralCallLogItemResponse } from '../models/RingCentralCallLogItemRsponse';
import { RingCentralCallLogRequest } from '../models/RingCentralCallLogRequest';
import { RingCentralTranscriptRequest } from '../models/RingCentralTranscriptRequest';
import { RingCentralTranscriptResponse } from '../models/RingCentralTranscriptResponse';

export class RingCentralService {

    /**
     * @returns RingCentralUserResponse Success
     * @throws ApiError
     */
    public static getApiRingCentralUsers(): CancelablePromise<Array<RingCentralExtensionResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/RingCentral/users',
        });
    }

    /**
     * @returns RingCentralExtensionResponse Success
     * @throws ApiError
     */
    public static getApiRingCentralExtensions(): CancelablePromise<Array<RingCentralExtensionResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/RingCentral/extensions',
        });
    }

    /**
     * @param requestBody 
     * @returns RingCentralExtensionResponse Success
     * @throws ApiError
     */
    public static getApiRingCentralCallLogs(requestBody?: RingCentralCallLogRequest): CancelablePromise<Array<RingCentralCallLogItemResponse>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/RingCentral/call-logs',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param requestBody 
     * @returns RingCentralExtensionResponse Success
     * @throws ApiError
     */
    public static getApiRingCentralTranscript(requestBody?: RingCentralTranscriptRequest): CancelablePromise<Array<RingCentralTranscriptResponse>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/RingCentral/transcript',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param requestBody 
     * @returns ZoomTableResponse Success
     * @throws ApiError
     */
    public static postApiZoomPending(
requestBody?: ZoomTableRequest,
): CancelablePromise<ZoomTableResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/RingCentral/pending',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public static postApiZoomMatter(
requestBody?: ZoomSetMatterRequest,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/RingCentral/matter',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public static postApiZoom(
requestBody?: ZoomSetMatterRequest,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/RingCentral',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public static postApiZoomBulk(
requestBody?: ZoomSetMatterRequest,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/RingCentral/bulk',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param id 
     * @returns any Success
     * @throws ApiError
     */
    public static postApiZoomStatusDeleted(
id: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/RingCentral/{id}/status/deleted',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns any Success
     * @throws ApiError
     */
    public static postApiZoomMeetingsWebhook(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/RingCentral/meetingsWebhook',
        });
    }

    /**
     * @returns any Success
     * @throws ApiError
     */
    public static postApiZoomWebhook(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/RingCentral/webhook',
        });
    }

    /**
     * @returns ZoomRecordingResponse Success
     * @throws ApiError
     */
    public static postApiZoomRecordings(requestBody?: ZoomRecordingRequest): CancelablePromise<Array<ZoomRecordingResponse>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/RingCentral/recordings',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }
}
